import React from 'react';
import './InputFeedback.css';

const InputFeedback = ({ error }) => (
  <div className="input-feedback">{error ? error : null}</div>
);

export default InputFeedback;
